import { Card, styled } from "@mui/material";

export const AboutPage = styled("div")(({ theme,dark }) => ({
  width: "100vw",
  height: "calc(100vh + 150px )",
  backgroundColor: dark? "#1C2028" :"#fff",
  //   backgroundColor: "red",
  maxHeight: "calc(100vh + 150px)",
  maxWidth: "100vw",
  overflow: "hidden",
  [theme.breakpoints.down("md")]: {
    height: "fit-content",
    maxHeight: "fit-content",
  },
}));

export const AboutScreen = styled("div")(({ theme,dark }) => ({
  width: "100vw",
  height: "calc(100vh - 50px)",
  padding: "20px 40px",
  display: "flex",
  flexDirection: "column",

  "& .page-title": {
    fontSize: "3em",
    color: dark?"#FF3B81":"#3957D2",
    fontWeight: 700,
    margin: "20px 0 0 0 ",
  },
  [theme.breakpoints.down("md")]: {
    height: "fit-content",
    maxHeight: "fit-content",
    "& .page-title": {
      fontSize: "2em",
    },
  },
}));

export const AboutMainContainer = styled("div")(() => ({
  width: "100%",
  flex: 1,
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
}));

export const AboutLottieContainer = styled("div")(({ theme }) => ({
  width: "40%",
  height: "100%",
  display: "grid",
  placeItems: "center",
  [theme.breakpoints.down("lg")]: {
    width: "50%",
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
    height: "50%",
  },
}));

export const AboutLottie = styled("div")(({ theme }) => ({
  width: "600px",
  height: "600px",
  [theme.breakpoints.down("lg")]: {
    width: 500,
    height: 500,
  },
  [theme.breakpoints.down("md")]: {
    width: 400,
    height: 400,
  },
}));

export const AboutDataContainer = styled("div")(({ theme }) => ({
  width: "60%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  // alignItems:'center',

  "& .links-container": {
    width: "60%",
    margin: "30px 0 0 30px",
    padding: "20px",
    display: "flex",
    flexDirection: "row",
  },

  [theme.breakpoints.down("lg")]: {
    width: "50%",
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
    height: "50%",
  },
}));

export const AboutCard = styled(Card)(({theme,dark}) => ({
  width: "80%",
  height: "fit-content",
  borderRadius: 10,
  boxShadow: "0px 8px 20px rgba(35, 35, 35, 0.1)",
  backgroundColor: dark?"#22262E": "#fff",
  padding: "30px 40px",
  fontSize: "1.2em",
  letterSpacing: "1px",
  // margin:'0 auto',
  margin: "20px 0 0 30px",
  color: dark?"#FF3B81":"#3957D2",
  border:dark?"1px solid #FF3B81":"",
  [theme.breakpoints.down('md')]:{
    width:'100%',
    margin:'20px 0 0 0',
  }
}));

export const ConnectionLink = styled("a")(({dark}) => ({
  width: "fit-content",
  height: "fit-content",
  padding: "15px",
  backgroundColor: "red",
  borderRadius: 5,
  backgroundColor: dark?"#22262E": "#fff",
  boxShadow: "0px 8px 20px rgba(35, 35, 35, 0.1)",
  display: "grid",
  placeItems: "center",
  margin: "0 20px 0 0",
  border:dark?"1px solid #FF3B81":"",

}));
